import React from 'react';
import { EDUCATION } from '../data';

export default function Education() {
  return (
    <section id="education" style={{ padding: '100px 0', borderTop: '1px solid rgba(26,26,26,0.06)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '64px' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.3em', color: 'var(--ink-light)', textTransform: 'uppercase', marginBottom: '16px' }}>Education</div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 1, letterSpacing: '-0.03em' }}>The Foundation</h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1px', border: '1px solid rgba(26,26,26,0.08)' }}>
          {EDUCATION.map((edu, i) => (
            <div key={i} className="fade-in" style={{ padding: '36px 32px', borderRight: i < EDUCATION.length - 1 ? '1px solid rgba(26,26,26,0.08)' : 'none', position: 'relative' }}>
              {edu.period === 'In Progress' && (
                <div style={{ position: 'absolute', top: '24px', right: '24px', fontFamily: 'var(--font-mono)', fontSize: '8px', letterSpacing: '0.2em', color: 'var(--accent)', border: '1px solid var(--accent)', padding: '3px 10px', textTransform: 'uppercase' }}>
                  In Progress
                </div>
              )}
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em', color: 'var(--ink-light)', textTransform: 'uppercase', marginBottom: '16px' }}>{edu.period}</div>
              <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: 600, color: 'var(--ink)', lineHeight: 1.2, marginBottom: '8px', letterSpacing: '-0.01em' }}>{edu.degree}</h3>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-mid)', fontWeight: 300, marginBottom: '4px' }}>{edu.school}</div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'var(--ink-light)', letterSpacing: '0.1em', marginBottom: '20px' }}>{edu.location}</div>
              <div style={{ width: '24px', height: '1px', background: 'var(--accent)', marginBottom: '16px', opacity: 0.6 }} />
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontStyle: 'italic', color: 'var(--ink-mid)', lineHeight: 1.6, fontWeight: 300 }}>{edu.highlight}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
